// src/components/MobileAccountMenu.jsx
import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Popup from "../components/Popup";
import { deleteAccount, logout } from "../store/slices/userSlice";
import {
  SvgDelete,
  SvgRdv,
  SvgFavoris,
  SvgInfoPerso,
  SvgPassword,
  SvgPaiementInfo,
  SvgLogout,
  SvgAccueil,
  SvgCalendar,
  SvgDemandeRdv,
  SvgMesRdv,
  SvgRemboursement,
  SvgAvis,
  SvgEtablissement,
  SvgPlanTarifaire,
  SvgGestionPaiement,
} from "./svg/Index";
import { getMyEtablissement } from "../store/slices/etablissementSlice";
import BackLink from "./BackLink";
const MobileAccountMenu = ({
  children,
  bgColor,
  rdvPage,
  review,
  childrenReview,
  linkBack = null,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false); // État du menu mobile
  const [isPopupVisible, setPopupVisible] = useState(false);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const { selectedEtablissement, isLoading, error } = useSelector(
    (state) => state.etablissements
  );
  useEffect(() => {
    if (user?.role === "prestataire") {
      dispatch(getMyEtablissement());
    }
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDeleteAction = () => {
    dispatch(deleteAccount());
    setPopupVisible(false);
  };
    const handleLogout = () => {
    dispatch(logout());
  };

  const menuItemsClient = [
    {
      key: "appointments",
      label: "Mes rendez-vous",
      icon: "appointments",
      link: "/compte/rendez-vous",
    },
    {
      key: "favoris",
      label: "Favoris",
      icon: "favoris",
      link: "/compte/favoris",
    },
    {
      key: "personal_info",
      label: "Informations personnelles",
      icon: "personal_info",
      link: "/compte/informations-personnel",
    },
    {
      key: "change_password",
      label: "Changer mon mot de passe",
      icon: "change_password",
      link: "/compte/changer-mot-de-passe",
    },
    {
      key: "payment_info",
      label: "Informations de paiement",
      icon: "payment_info",
      link: "/compte/informations-paiement",
    },
    { isDivider: true },
        {
      key: "logout",
      label: "Déconnexion",
      isDanger: false,
      icon: "logout",
      link: "#",
      onClick:  handleLogout ,
    },
  ];

  const menuItemsPresta = [
    {
      key: "accueil",
      label: "Accueil",
      icon: "accueil",
      link: "/compte/prestataire/accueil",
    },
    {
      key: "agenda",
      label: "Agenda",
      icon: "agenda",
      link: "/compte/prestataire/agenda",
    },
    {
      key: "demandes_rendez-vous",
      label: "Demandes de rendez-vous",
      icon: "demandes_rendez-vous",
      link: "/compte/prestataire/demande-rendez-vous",
    },
    {
      key: "mes_rendez-vous",
      label: "Mes rendez-vous",
      icon: "mes_rendez-vous",
      link: "/compte/prestataire/rendez-vous",
    },
    {
      key: "avis_clients",
      label: "Avis clients",
      icon: "avis_clients",
      link: "/compte/prestataire/avis-clients",
    },
    {
      key: "page_etablissement",
      label: "Ma page d’établissement",
      icon: "page_etablissement",
      link: "/compte/prestataire/page-etablissement",
    },
    {
      key: "plan_forfaitaire",
      label: "Mon plan forfaitaire",
      icon: "plan_forfaitaire",
      link: "/compte/prestataire/mon-plan",
    },
    {
      key: "gestion_paiements",
      label: "Gestion des paiements",
      icon: "gestion_paiements",
      link: "/compte/prestataire/mes-paiements",
    },
    {
      key: "informations_personnelles",
      label: "Informations personnelles",
      icon: "informations_personnelles",
      link: "/compte/informations-personnel",
    },
    {
      key: "Changer_mot_de_passe",
      label: "Changer mon mot de passe",
      icon: "Changer_mot_de_passe",
      link: "/compte/changer-mot-de-passe",
    },
    { isDivider: true },

        {
      key: "logout",
      label: "Déconnexion",
      isDanger: false,
      icon: "logout",
      link: "#",
      onClick:  handleLogout ,
    },
  ];



  const renderEtablissementCompleted = (key) => {
    // console.log(selectedEtablissement)
    if (
      key === "page_etablissement" &&
      selectedEtablissement?.is_complete === 0
    ) {
      return (
        <img
          src="/images/notCompleted.svg"
          alt="not completed icon"
          className="ml-8"
        />
      );
    }
  };

  const renderIconClient = (iconKey) => {
    switch (iconKey) {
      case "appointments":
        return <SvgRdv />;
      case "favoris":
        return <SvgFavoris />;

      case "personal_info":
        return <SvgInfoPerso />;
      case "change_password":
        return <SvgPassword />;
      case "payment_info":
        return <SvgPaiementInfo />;
       case "logout":
         return <SvgLogout />;
      default:
        return null;
    }
  };

  const renderIconPresta = (iconKey) => {
    switch (iconKey) {
      case "accueil":
        return <SvgAccueil />;
      case "agenda":
        return <SvgCalendar />;

      case "demandes_rendez-vous":
        return <SvgDemandeRdv />;
      case "mes_rendez-vous":
        return <SvgMesRdv />;
      case "demandes_remboursement":
        return <SvgRemboursement />;
      case "avis_clients":
        return <SvgAvis />;
      case "page_etablissement":
        return <SvgEtablissement />;
      case "plan_forfaitaire":
        return <SvgPlanTarifaire />;
      case "gestion_paiements":
        return <SvgGestionPaiement />;
      case "informations_personnelles":
        return <SvgPaiementInfo />;
      case "Changer_mot_de_passe":
        return <SvgPassword />;
       case "logout":
         return <SvgLogout />;
      default:
        return null;
    }
  };

  const SidebarContent = () => (
    <div className="sidebar">
      <div className="menu-items">
        {menuItemsClient.map((item, index) =>
          item.isDivider ? (
            <div key={index} className="divider"></div>
          ) : (
            <Link
              to={item.link}
              key={item.key}
              className={`menu-item ${
                location.pathname === item.link ? "active" : ""
              } ${item.isDanger ? "danger-section" : ""}`}
              onClick={(e) => {
                if (item.onClick) {
                  item.onClick(e);
                }
                setShowOffcanvas(false);
              }}
            >
              {renderIconClient(item.icon)}
              {item.label}
            </Link>
          )
        )}
      </div>
      <button className="logout-btn" onClick={() => setPopupVisible(true)}>
        <span></span>
        <span className="body error-text">Supprimer le compte</span>
      </button>
    </div>
  );
  const PrestaBarContent = () => (
    <div className="sidebar">
      <div className="menu-items">
        {menuItemsPresta.map((item, index) =>
          item.isDivider ? (
            <div key={index} className="divider"></div>
          ) : (
            <Link
              to={item.link}
              key={item.key}
              className={`menu-item ${
                location.pathname === item.link ? "active" : ""
              } ${item.isDanger ? "danger-section" : ""}`}
              onClick={(e) => {
                if (item.onClick) {
                  item.onClick(e);
                }
                setShowOffcanvas(false);
              }}
            >
              {renderIconPresta(item.icon)}
              {item.label}
              {renderEtablissementCompleted(item.key)}
            </Link>
          )
        )}
      </div>
      <button className="logout-btn" onClick={() => setPopupVisible(true)}>
        <span></span>
        <span className="body error-text">Supprimer le compte</span>
      </button>
    </div>
  );

  return (
    <div>
      {/* Burger menu - Toggler */}
      <button
        className="navbar-toggler"
        type="button"
        onClick={toggleMenu}
        aria-controls="offcanvasNavbar"
        aria-expanded={isMenuOpen ? "true" : "false"}
        aria-label="Toggle navigation"
      >
        <img src="/menu-button.png" />
      </button>
      {/* Offcanvas menu */}
      <div
        className={`offcanvas offcanvas-start ${isMenuOpen ? "show" : ""}`}
        tabIndex="-1"
        id="offcanvasNavbar"
        aria-labelledby="offcanvasNavbarLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
            <Link to="/">
              <img  src="/images/twyLogo.svg" alt="Twyny Logo" className="logo-img" />
            </Link>
          </h5>
          <button
            type="button"
            className="btn-close text-reset"
            onClick={toggleMenu}
            aria-label="Close"
          ></button>
        </div>
        <div className="row">
          <div className="col-lg-9">{linkBack && <BackLink />}</div>
        </div>
        <div className="bodyHomeMenu offcanvas-body">
          <div>
            {user?.role == "user" ? <SidebarContent /> : <PrestaBarContent />}
          </div>
        </div>
      </div>
      <Popup
        isOpen={isPopupVisible}
        onClose={() => setPopupVisible(false)}
        onAction={handleDeleteAction}
        title="Voulez vous vraiment supprimer votre compte ?"
        text={
          <p className="body">
            Si vous avez des rendez-vous prévus, ceux-ci disparaîtront de Twyny.
            Pour plus d'informations, consultez notre{" "}
            <a href="/politique-confidentialite" className=" body text-decoration-none" target="_blank">
              Charte de confidentialité
            </a>
            .
          </p>
        }
        actionButtonText="Supprimer mon compte"
        closeButtonText="Annuler"
        closeButtonClassName="bold600"
        color="red"
        icon={<SvgDelete />}
      />
    </div>
  );
};

export default MobileAccountMenu;
